/**
 * HTML ENTITIES CONSTANTS
 *
 * HTML entity mappings for safe escaping of user content.
 * Used for XSS protection when displaying potentially dangerous characters.
 */

// HTML ENTITIES - For safe escaping of dangerous characters
export const HTML_ENTITIES = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '/': '&#x2F;',
  '|': '&#x7C;',
  '(': '&#x28;',
  ')': '&#x29;',
  '{': '&#x7B;',
  '}': '&#x7D;',
  '[': '&#x5B;',
  ']': '&#x5D;',
  ';': '&#x3B;',
  ':': '&#x3A;',
  '=': '&#x3D;',
  '\\': '&#x5C;',
  '%': '&#x25;',
  '#': '&#x23;',
  '+': '&#x2B;',
  $: '&#x24;',
  '`': '&#x60;',
  '~': '&#x7E;',
  '^': '&#x5E;',
  '*': '&#x2A;',
} as const;
